var exports = {
  "kL": "VoiceMessagePlayer.module__container___eXZuMl",
  "Kd": "VoiceMessagePlayer.module__containerActive___eXZuMl",
  "hd": "VoiceMessagePlayer.module__waveformBar___eXZuMl",
  "x5": "VoiceMessagePlayer.module__waveformBarPast___eXZuMl",
  "Rr": "VoiceMessagePlayer.module__playButton___eXZuMl",
  "CJ": "VoiceMessagePlayer.module__playButtonIcon___eXZuMl",
  "S": "VoiceMessagePlayer.module__loadingSpinner___eXZuMl",
  "t0": "VoiceMessagePlayer.module__spin___eXZuMl",
  "FU": "VoiceMessagePlayer.module__waveformContainer___eXZuMl",
  "vE": "VoiceMessagePlayer.module__timestamp___eXZuMl",
  "NS": "VoiceMessagePlayer.module__speedControl___eXZuMl",
  "Wq": "VoiceMessagePlayer.module__volumeControl___eXZuMl",
};

module.exports = exports;
